<template>
  <!-- A pergunta do app, a mesma de remover um membro e do "mover ou acrescentar". Diz que o item
       continua existindo, para não se ler "excluir". -->
  <ontos-ask-dialog :title="$tt('relationship-unlink-confirm', names)"
                    :message="$tt('relationship-unlink-explain', names)"
                    :actions="actions"
                    @pick="onPicked($event)"
                    @closed="$emit('closed')"/>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import AskDialog, {Ask} from '@/components/shared/AskDialog.vue'
import Idea from '@/types/Idea'
import IdeaProperty from '@/types/IdeaProperty'
import {InstanceContext} from '@/types/InstanceContext'
import {EnhancedWorkpace} from '@/types/Workspace'
import {unlinkFromOwner} from '@/utils/relationshipKanban'
import {refuse} from '@/utils/refusal'

/**
 * Desvincular um item do dono: o X da linha e do card. Pergunta, e confirmado grava pelo dono
 * (`unlinkFromOwner`); daqui sai o `unlinked` com o id, e quem mostra o relacionamento tira o item da
 * tela sem reler (`withRelated`).
 *
 * Componente, e não marcação em quem usa: a ficha e a página do quadro expandido mostram o mesmo
 * relacionamento, e o quadro expandido tinha ficado sem o X (relato do usuário).
 */
@Component({
  emits: ['unlinked', 'closed', 'showMessage'],
  name: 'ontos-relationship-unlink-dialog',
  components: {'ontos-ask-dialog': AskDialog}
})
class RelationshipUnlinkDialog extends Vue {
  @Prop({type: Object, required: true}) readonly ownerContext!: InstanceContext
  /** O dono carregado, com `_rels` — é dali que sai a lista que fica. */
  @Prop({type: Object, required: true}) readonly owner!: any
  @Prop({type: Object, required: true}) readonly property!: IdeaProperty
  /** O item a tirar, com `_instance` e `_identifier`. */
  @Prop({type: Object, required: true}) readonly item!: any
  @Prop({required: true}) readonly workspace!: EnhancedWorkpace

  get ownerIdea(): Idea {
    return this.workspace.ideaWith(this.ownerContext.idea)!
  }

  get names() {
    return {item: this.item._identifier, owner: this.owner._identifier, property: this.property.name}
  }

  get actions(): Ask[] {
    return [
      {value: 'unlink', label: this.$tt('relationship-unlink') as string, icon: 'mdi-link-variant-off', color: 'error'},
      {value: '', label: this.$tt('cancel') as string, text: true}
    ]
  }

  async onPicked(action: string) {
    if (action !== 'unlink') return this.$emit('closed')
    const id = Number(this.item._instance)
    try {
      await unlinkFromOwner(this.$instances, this.ownerContext, this.owner, this.property, id)
      this.$emit('unlinked', id)
      //A mensagem de salvo, como em toda gravação do app
      this.$emit('showMessage', this.$tt('info.relationship-unlinked', {name: this.item._identifier}))
    } catch (err) {
      //A recusa do servidor dita na língua da tela — a mesma frase da edição do dono —, na janela
      refuse(err, this.ownerIdea)
      this.$emit('closed')
    }
  }
}

export default toNative(RelationshipUnlinkDialog)
</script>
